import { MenuItem } from "primereact/menuitem";
import { NavLink } from "./NavLinks";

export type NavItem = MenuItem & {
  index: number;
  url: string;
};

export const navItems: NavItem[] = [
  {
    label: "Start",
    icon: "pi pi-fw pi-home",
    url: NavLink.START,
    index: 0,
  },
  {
    label: "Meldungen",
    icon: "pi pi-fw pi-exclamation-triangle",
    url: NavLink.ALARMS,
    index: 1,
  },
  {
    label: "Meldeinstanzen",
    icon: "pi pi-fw pi-share-alt",
    url: NavLink.DEVICES,
    index: 2,
  },
  {
    label: "Szenarien",
    icon: "pi pi-fw pi-tags",
    url: NavLink.SCENARIOS,
    index: 3,
  },
  {
    label: "Notfallkontakte",
    icon: "pi pi-fw pi-user",
    url: NavLink.CONTACTS,
    index: 4,
  },
  {
    label: "Kontaktgruppen",
    icon: "pi pi-fw pi-users",
    url: NavLink.CONTACT_GROUPS,
    index: 5,
  },
];
